import {Component, OnInit} from '@angular/core';
import {APP_CONFIG} from '../../app.config';
import {LoginComponent} from "../login/sso/login.component";
import {take} from 'rxjs/operators';

@Component({
    selector: 'core-maintenance',
    templateUrl: './maintenance.component.html',
    standalone: false
})
export class MaintenanceComponent extends LoginComponent implements OnInit {

    override ngOnInit() {
        super.ngOnInit();
        this.titleService.setTitle('Maintenance | ' + APP_CONFIG.appName);
        this.auth.initialise().pipe(
            take(1),
        ).subscribe(() => {
            if (this.auth.serviceProvider.status === 'ACTIVE') {
                this.router.navigate(['/']);
            }
        });
    }
}
